import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import classnames from 'classnames'
import { Dialog, Modal } from 'antd-mobile'
import { postMessage } from '../../../utils'
import CardGameItemImg from '../../../assets/events/card_game/type_qx/card-game-item.png'
import CardGameRecordBtn from '../../../assets/img/card-game-record-btn.png'

let cardConfig = []

for (let i = 0; i < 6; i++) {
  cardConfig.push({ rolling: false, key: i })
}

// let Btn = (props) => {
//   return <div className='card-game__button'{...props} />
// }

class CardGameItem extends React.PureComponent {
  static propTypes = {
    rolling: PropTypes.bool
  }

  render () {
    const { rolling, ...props } = this.props
    let classNames = classnames('card-game__item', { 'card-game__item--rolling': rolling })
    return <img src={CardGameItemImg} className={classNames} {...props} alt=""/>
  }

}

@withRouter
class CardGameBlock extends React.PureComponent {

  state = {
    modalVisible: false,
    count: 0,
    joinCount: 0, // 本日下单次数，判断抽奖次数是用完还是因为本日未下单
    cardConfig,
    rolling: false,
    rollKey: null,
    lotteryPrize: {}
  }

  invalidLogin = false

  componentDidMount () {
    window.toast.show()
    this.getLotteryConfig()
      .then(this.handleLotteryConfig)
      .catch(e => {
        console.error(e)
        if (e.message.match('登录过期')) {
          this.alertLoginModal('登陆过期')
          this.invalidLogin = true
        }
      })
      .finally(() => {
        window.toast.hide()
        if (!sessionStorage.getItem('token')) {
          this.alertLoginModal()
          this.invalidLogin = true
        }
      })
  }

  render () {
    const { count, cardConfig, modalVisible, lotteryPrize } = this.state
    const { giftImgUrl: modalUrl } = lotteryPrize
    // const modalUrl = 'http://cdn.dev.hnqcwlkj.com/1702865661183.png'
    return <div>
      <div className={'card-game__block'}>
        {cardConfig.map(item => <CardGameItem key={item.key} rolling={item.rolling}
                                              onClick={this.onCardClick.bind(this, item.key)}/>)}
        <div className={'card-game__text'}>
          您有 <span>{count}</span> 次翻牌机会
        </div>

        <div className={'card-game__record'}>
          <img src={CardGameRecordBtn} alt="" onClick={this.goToLog}/>
        </div>
      </div>
      {/*<div className={'card-game__line'}>*/}
      {/*  <Btn>今日有 {count} 次翻牌机会</Btn>*/}
      {/*  <Btn style={{ marginLeft: 10 }} onClick={this.goToLog}>获奖记录</Btn>*/}
      {/*</div>*/}
      <Modal
        className={'turntable__modal'}
        bodyClassName={'!bg-transparent'}
        visible={modalVisible}
        content={<div className="flex flex-col justify-center items-center">
          {
            modalUrl
              ? <img src={modalUrl} className={'w-full h-auto'} alt=""
                     onClick={this.clickModal}/>
              : <div className={'turntable__modal__text'}>
                抽奖程序出错，请将此界面截图至客服。
                <br/>
                {JSON.stringify(lotteryPrize)}
                <br/>
              </div>
          }
          <div className={'turntable__modal__icon'} onClick={this.closeModal}>
            <i className={'icon-font icon-close'} />
          </div>
        </div>}
      />
    </div>
  }

  goToLog = () => {
    this.props.history.push(window.PATH.CARD_GAME_LOG)
  }

  onCardClick = key => {
    if (this.invalidLogin) {
      this.alertLoginModal()
      return
    } else if (this.state.joinCount === 0) {
      Dialog.alert({
        title: '抱歉',
        content: '请订购指定商品后再翻牌哦'
      }).then()
      return
    }
    if (this.state.rolling) return
    let newConfig = [...this.state.cardConfig]
    newConfig[key] = { rolling: true, key }
    this.setState({ cardConfig: newConfig, rolling: true, rollKey: key }, this.postLottery)
  }

  closeModal = () => {
    this.setState({
      modalVisible: false
    })
  }

  clickModal = () => {
    const { giftType, extMap } = this.state.lotteryPrize
    this.setState({ modalVisible: false }, () => {
      switch (giftType) {
        case 1:
          // 积分奖品，转跳至积分商城
          this.props.history.push(window.PATH.INTEGRAL)
          break
        case 2:
          // 订购券奖品，转跳至对应下单页
          postMessage({
            type: window.POST_TYPE.BUY,
            data: this.state.lotteryPrize
          })
          break
        case 4:
          // 零售券奖品，若有id则对应至对应详情页，无则商城首页
          let { productId } = extMap
          if (productId) {
            this.props.history.push(`${window.PATH.MALL_PRODUCT_DETAILS}/${productId}`)
          } else {
            this.props.history.push(window.PATH.MALL_HOME)
          }
          break
        default:
          return
      }
    })
  }

  handleRollingStop = () => {
    let newConfig = [...this.state.cardConfig]
    newConfig[this.state.rollKey] = { rolling: false, key: this.state.rollKey }
    this.setState({ cardConfig: newConfig, rolling: false, rollKey: null })
  }

  alertLoginModal = (title = '未登陆') => {
    Dialog.confirm({
      title,
      content: '参加抽奖请先登陆账号',
      onConfirm: () => {postMessage(window.POST_TYPE.LOGIN_REQUEST)}
    }).then()
  }

  handleLotteryConfig = res => {
    this.setState({ count: res.count, joinCount: res.joinCount })
  }

  getLotteryConfig = () => {
    let config = { url: window.API.CardGame.getLotteryConfig }
    return window.axios.request(config)
  }

  postLottery = () => {
    // 判断是否登陆
    if (!sessionStorage.getItem('token')) {
      this.alertLoginModal()
      return
    } else if (this.loading) return
    this.loading = true
    // window.toast.show('请求中...')
    let config = {
      method: 'post',
      url: window.API.CardGame.postLottery
    }
    window.axios.request(config)
      .then(res => {
        this.loading = false
        this.setState({
          lotteryPrize: res,
          modalVisible: true
        })
        this.getLotteryConfig().then(this.handleLotteryConfig).catch(e => console.error(e))
      })
      .catch(e => {
        this.loading = false
        let msg = e.message
        if (msg.match('参与抽奖次数已满')) msg = '今日抽奖次数已用完'
        Dialog.alert({
          title: '抱歉', content: msg
        }).then()
        console.error(e)
      })
      .finally(() => {
        window.toast.hide()
        // 翻牌停止
        this.handleRollingStop()
      })
  }

}

export default CardGameBlock
